export default {
  settings: {
    server: "https://apinew.goldwaretech.com/",
    // server: "https://api.gwtech.ir/",
    //server: "http://localhost:58771/",
    // server: "http://localhost:5000/",
    //server: "https://gwapi.iran.liara.run/",
  },
  snackBar: {
    active: false,
    body: "",
  },
  loadingDialog: false,
  drawer: true,
  expandOnHover: true,
  userInfo: {
    accessToken: "",
    refreshToken: "",
  },
  dashboard: {},
  devices: [],
  users: [],
  deviceStatus: "",
  dashboard: {},
  pingInfo: [],
  groups: [],
  groupinfo: {},
  keyStatus: {},
  userAccesses: [],
  icons: [
    { id: 1, name: "ic-bridge", data: "mdi-square-rounded-outline" },
    { id: 2, name: "ic-BedsideLamp", data: "mdi-lamp" },
    { id: 3, name: "ic-Chandelier", data: "mdi-chandelier" },
    { id: 4, name: "ic-Coffee", data: "mdi-coffee" },
    { id: 5, name: "ic-Cold", data: "mdi-snowflake" },
    { id: 6, name: "ic-Currtain-Close", data: "mdi-curtains-closed" },
    { id: 7, name: "ic-Currtain-Open", data: "mdi-curtains" },
    { id: 8, name: "ic-Elec1", data: "mdi-flash" },
    { id: 9, name: "ic-Electricity", data: "mdi-power-plug" },
    { id: 10, name: "ic-Fan", data: "mdi-fan" },
    { id: 11, name: "ic-Fan_2.png", data: "mdi-ceiling-fan-light" },
    { id: 12, name: "ic-Faucet", data: "mdi-water-plus-outline" },
  ],
};
